import { createRouter, createWebHistory } from 'vue-router'
import { isAuthenticated, runtimeConfig } from '@ck/auth'
import HomeView from './views/HomeView.vue'
import LoginView from './views/LoginView.vue'
import VeiculoView from './views/VeiculoView.vue'
import ChecklistView from './views/ChecklistView.vue'
import NovaOsView from './views/NovaOsView.vue'
import FotosView from './views/FotosView.vue'
import PerfilView from './views/PerfilView.vue'
import RelatoriosView from './views/RelatoriosView.vue'
import HistoricoView from './views/HistoricoView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    { path: '/auth/callback', redirect: '/' },
    { path: '/', name: 'home', component: HomeView },
    { path: '/veiculo/:id', name: 'veiculo', component: VeiculoView, props: true },
    { path: '/veiculo/:id/etapa/:stageId', name: 'checklist', component: ChecklistView, props: true },
    { path: '/nova-os', name: 'nova-os', component: NovaOsView },
    { path: '/fotos', name: 'fotos', component: FotosView },
    { path: '/perfil', name: 'perfil', component: PerfilView },
    { path: '/relatorios', name: 'relatorios', component: RelatoriosView },
    { path: '/historico', name: 'historico', component: HistoricoView },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
})

router.beforeEach((to) => {
  const authenticated = isAuthenticated()
  if (!to.meta.public && !authenticated) return { name: 'login' }
  if (to.name === 'login' && authenticated && runtimeConfig.authRequired) return { name: 'home' }
  return true
})

export default router
